// Chaves de Remote Config do painel de Funcionalidades, e o default de cada uma.
//
// Módulo PURO de propósito: sem firebase, sem expo. `features-service.js` faz o
// I/O e importa daqui, o que deixa a regra de default coberta por teste
// (`feature-keys.test.js`) sem precisar subir o SDK.

export const GROWTH_KEYS = [
  'hasForm',
  'hasComments',
  'hasProfileInfos',
  'hasProgress',
  'blockDownloadPdf',
  'blockScreenCapture',
  'hasProductCatalog',
];

export const PREMIUM_ONLY_KEYS = [
  'hasPlanner',
  'hasGeneralNotifications',
  'hasCommunity',
  'hasDownload',
];

export const ALL_BOOLEAN_KEYS = [...GROWTH_KEYS, ...PREMIUM_ONLY_KEYS];

export const PREMIUM_ONLY_SET = new Set(PREMIUM_ONLY_KEYS);

// Chaves cujo valor, ENQUANTO o Remote Config não respondeu, é `true`.
//
// Todas as outras nascem `false`: são funcionalidades, e uma funcionalidade só
// deve ligar quando alguém a ligou de propósito. `blockScreenCapture` é o
// inverso — é uma TRAVA de segurança protegendo conteúdo pago, então o estado
// seguro é "ligada". Só um `false` publicado deliberadamente a desliga; rede
// caída, throttle do Remote Config ou cliente novo (parâmetro ainda nem existe
// no template) mantêm a proteção de pé.
export const SECURE_BY_DEFAULT_KEYS = new Set(['blockScreenCapture']);

/** Valor de uma chave quando o Remote Config ainda não trouxe nada para ela. */
export function getSecureDefault(key) {
  return SECURE_BY_DEFAULT_KEYS.has(key);
}

/**
 * Resolve o valor final de uma chave a partir do que o Remote Config devolveu.
 *
 * @param {string} key
 * @param {{ isRemote: boolean, value: boolean }} remote leitura do SDK
 */
export function resolveFlag(key, { isRemote, value }) {
  if (!isRemote) return getSecureDefault(key);
  return value;
}
